import React from 'react';
import type { IconProps } from '../Icon/types';
/* istanbul ignore file */
function IconAddDefault({
  srText,
  size = 'md',
  className = '',
  ...props
}: IconProps) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={24} height={25} fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><path fill="currentColor" fillRule="evenodd" d="M2 12.5c0-.637.517-1.154 1.154-1.154h17.692a1.154 1.154 0 1 1 0 2.308H3.154A1.154 1.154 0 0 1 2 12.5" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="M12 2.5c.637 0 1.154.517 1.154 1.154v17.692a1.154 1.154 0 1 1-2.308 0V3.654c0-.637.517-1.154 1.154-1.154" clipRule="evenodd" /></svg></>;
}
export default IconAddDefault;